var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-sort-desc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5h10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9h7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m3 17 3 3 3-3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18V4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default __webpack_public_path__ + "static/media/sort-desc.fa6008a6eb9fdc194c558668a5763d2f.svg";
export { ForwardRef as ReactComponent };